import { Dialog, DialogContent } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'

const ModalSynthese = ({ open, toggleModal, push }) => {
    const handleClose = () => {
        push()
        toggleModal()
    }

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            open={open}
        >
            <DefaultDialogTitle title={'Déclaration terminée'} onClose={handleClose}/>
            <DialogContent>
                <p id='modal-text'>
                    La synthèse de votre déclaration est disponible dans "Mes documents".
                </p>
                <p id='modal-description' className='italic-label'>{i18n.contactAdmin}</p>
            </DialogContent>
        </Dialog>
    )
}

ModalSynthese.propTypes = {
    open: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
}
export default ModalSynthese